(function(){
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var SEK = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 0 });
  function money(n){ return SEK.format(Math.round(n)) + ' kr'; }

  function countUp(el, to){
    var from = parseFloat(el.getAttribute('data-v') || '0');
    el.setAttribute('data-v', to);
    el.textContent = money(to);
    if (REDUCED || typeof requestAnimationFrame !== 'function' || from === to) return;
    var t0 = null;
    function step(t){
      if (t0 === null) t0 = t;
      var p = Math.min(1, (t - t0) / 700);
      var e = 1 - Math.pow(1 - p, 3);
      el.textContent = money(from + (to - from) * e);
      if (p < 1) requestAnimationFrame(step); else el.textContent = money(to);
    }
    requestAnimationFrame(step);
  }

  function init(root){
    if (!root || root.dataset.djInit) return;
    root.dataset.djInit = '1';

    root.querySelectorAll('[data-dj-inline-variant]').forEach(function(select){
      select.addEventListener('change', function(){
        var option = select.options[select.selectedIndex];
        var card = select.closest('.dj-lst__inline-cta');
        var image = card && card.querySelector('[data-dj-inline-image]');
        if (!option || !image) return;
        var source = option.getAttribute('data-image') || '';
        if (source){
          image.src = source;
          image.alt = option.getAttribute('data-alt') || '';
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.hidden = true;
        }
      });
    });

    root.querySelectorAll('[data-dj-sticky-variant]').forEach(function(select){
      var trigger = select.closest('.dj-lst__sticky-variant-trigger');
      var button = trigger && trigger.querySelector('[data-dj-sticky-variant-button]');
      var baseLabel = select.getAttribute('aria-label') || 'Välj modell';

      function syncVariant(){
        var option = select.options[select.selectedIndex];
        var stickyRoot = select.closest('[data-dj-sticky]');
        if (!option || !stickyRoot) return;
        var now = stickyRoot.querySelector('[data-dj-sticky-now]');
        var was = stickyRoot.querySelector('[data-dj-sticky-was]');
        var image = stickyRoot.querySelector('[data-dj-sticky-image]');
        if (button) button.setAttribute('aria-label', baseLabel + '. Vald: ' + option.textContent.trim());
        if (now) now.textContent = option.getAttribute('data-price') || '';
        if (was){
          var compare = option.getAttribute('data-compare') || '';
          was.textContent = compare;
          was.hidden = !compare;
        }
        if (image){
          var source = option.getAttribute('data-image') || '';
          if (source){
            image.src = source;
            image.alt = option.getAttribute('data-alt') || '';
            image.hidden = false;
          } else {
            image.removeAttribute('src');
            image.hidden = true;
          }
        }
      }

      if (trigger && button){
        trigger.classList.remove('dj-lst__sticky-variant-trigger--picker-api');
        button.setAttribute('aria-hidden', 'true');
        button.tabIndex = -1;
        button.style.pointerEvents = 'none';
      }
      select.removeAttribute('aria-hidden');
      select.tabIndex = 0;

      select.addEventListener('change', syncVariant);
      syncVariant();
    });

    var journeyState = { problem: '', priority: '', fit: '' };

    function updatePersonalized(){
      root.querySelectorAll('[data-dj-personalized]').forEach(function(el){
        var chosen = journeyState.priority || journeyState.problem || journeyState.fit;
        var prefix = el.getAttribute('data-prefix') || '';
        var fallback = el.getAttribute('data-fallback') || '';
        el.textContent = chosen ? prefix + ' ' + chosen : fallback;
      });
    }

    root.querySelectorAll('[data-dj-friction]').forEach(function(calc){
      var range = calc.querySelector('[data-dj-friction-range]');
      var input = calc.querySelector('[data-dj-friction-input]');
      var rangeOut = calc.querySelector('[data-dj-friction-range-output]');
      var result = calc.querySelector('[data-dj-friction-result]');
      var mode = calc.getAttribute('data-mode') || 'cost';
      var multiplier = Number(calc.getAttribute('data-multiplier')) || 1;
      var unit = rangeOut ? (rangeOut.textContent || '').replace(/^\s*[\d.,]+\s*/, '') : '';
      var format = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 1 });
      function update(){
        var quantity = Math.max(0,Number(range && range.value)||0);
        var value = Math.max(0,Number(input && input.value)||0);
        if (rangeOut) rangeOut.textContent = format.format(quantity) + (unit ? ' ' + unit : '');
        if (range){
          var min=Number(range.min)||0,max=Number(range.max)||1;
          range.style.setProperty('--dj-range',Math.max(0,Math.min(100,(quantity-min)/Math.max(1,max-min)*100))+'%');
        }
        if (!result) return;
        if (mode === 'time'){
          var hours = quantity * value * multiplier * 52 / 60;
          result.textContent = value > 0 ? format.format(hours) + ' timmar per år' : 'Ange din egen tid ovan';
        } else {
          var cost = quantity * value * multiplier;
          result.textContent = value > 0 ? format.format(cost) + ' kr' : 'Ange din egen kostnad ovan';
        }
      }
      if(range)range.addEventListener('input',update);
      if(input)input.addEventListener('input',update);
      update();
    });

    root.querySelectorAll('[data-dj-choice-group]').forEach(function(group){
      var mode = group.getAttribute('data-dj-choice-mode') || 'single';
      var buttons = [].slice.call(group.querySelectorAll('[data-dj-choice]'));
      var result = group.querySelector('[data-dj-choice-result] p');
      var defaultText = result ? result.textContent : '';

      function syncChoice(){
        var selected = buttons.filter(function(btn){ return btn.getAttribute('aria-pressed') === 'true'; });
        if (result){
          if (!selected.length) result.textContent = defaultText;
          else result.textContent = selected.map(function(btn){ return btn.getAttribute('data-insight') || ''; }).filter(Boolean).join(' ');
        }
        var first = selected[0];
        var personal = first ? (first.getAttribute('data-personal') || '') : '';
        if (group.hasAttribute('data-dj-priority-group')) journeyState.priority = personal;
        else journeyState.problem = personal;
        updatePersonalized();
      }

      buttons.forEach(function(btn){
        btn.addEventListener('click', function(){
          var next = btn.getAttribute('aria-pressed') !== 'true';
          if (mode === 'single') buttons.forEach(function(other){ other.setAttribute('aria-pressed','false'); });
          btn.setAttribute('aria-pressed', next ? 'true' : 'false');
          syncChoice();
        });
      });
    });

    root.querySelectorAll('[data-dj-tabs]').forEach(function(tabs){
      var buttons = [].slice.call(tabs.querySelectorAll('[data-dj-tab]'));
      var panel = tabs.querySelector('[data-dj-tab-panel]');
      if (!buttons.length || !panel) return;
      var heading = panel.querySelector('h3');
      var copy = panel.querySelector('p');

      function selectTab(btn, focus){
        buttons.forEach(function(other){ other.setAttribute('aria-selected', other === btn ? 'true' : 'false'); });
        if (heading) heading.textContent = btn.getAttribute('data-title') || '';
        if (copy) copy.textContent = btn.getAttribute('data-copy') || '';
        if (focus) btn.focus();
      }

      buttons.forEach(function(btn, index){
        btn.addEventListener('click', function(){ selectTab(btn, false); });
        btn.addEventListener('keydown', function(event){
          var delta = event.key === 'ArrowRight' || event.key === 'ArrowDown' ? 1 : event.key === 'ArrowLeft' || event.key === 'ArrowUp' ? -1 : 0;
          if (!delta) return;
          event.preventDefault();
          selectTab(buttons[(index + delta + buttons.length) % buttons.length], true);
        });
      });
    });

    root.querySelectorAll('[data-dj-routine]').forEach(function(routine){
      var range = routine.querySelector('[data-dj-routine-range]');
      var before = routine.querySelector('[data-dj-routine-before]');
      var after = routine.querySelector('[data-dj-routine-after]');
      function syncRoutine(){
        var value = Number(range && range.value) || 50;
        if (before){ before.classList.toggle('is-active', value < 50); before.classList.toggle('is-muted', value >= 65); }
        if (after){ after.classList.toggle('is-active', value >= 50); after.classList.toggle('is-muted', value <= 35); }
      }
      if (range) range.addEventListener('input', syncRoutine);
      syncRoutine();
    });

    root.querySelectorAll('[data-dj-fit]').forEach(function(fit){
      var options = [].slice.call(fit.querySelectorAll('[data-dj-fit-option]'));
      var box = fit.querySelector('[data-dj-fit-result]');
      var out = box && box.querySelector('p');
      function syncFit(){
        var selected = options.filter(function(option){ return option.checked; });
        if (out){
          var base = selected.length ? (box.getAttribute('data-positive') || '') : (box.getAttribute('data-empty') || '');
          var first = selected[0] && selected[0].getAttribute('data-personal');
          out.textContent = first ? base + ' Särskilt relevant för dig: ' + first + '.' : base;
        }
        journeyState.fit = selected[0] ? (selected[0].getAttribute('data-personal') || '') : '';
        updatePersonalized();
      }
      options.forEach(function(option){ option.addEventListener('change', syncFit); });
      syncFit();
    });

    updatePersonalized();

    root.querySelectorAll('[data-dj-review-explorer]').forEach(function(explorer){
      var filters = [].slice.call(explorer.querySelectorAll('[data-dj-review-filter]'));
      var spotlight = explorer.querySelector('[data-dj-review-spotlight]');
      var name = spotlight && spotlight.querySelector('[data-dj-review-spotlight-name]');
      var copy = spotlight && spotlight.querySelector('[data-dj-review-spotlight-copy]');
      var stars = spotlight && spotlight.querySelector('[data-dj-review-spotlight-stars]');
      function showTheme(button){
        var tag = button.getAttribute('data-dj-review-filter') || '';
        var review = root.querySelector('.dj-lst__review[data-review-tag="' + CSS.escape(tag) + '"]');
        filters.forEach(function(other){ other.setAttribute('aria-pressed', other === button ? 'true' : 'false'); });
        if (review && name && copy){
          var reviewName = review.querySelector('figcaption');
          var reviewCopy = review.querySelector('blockquote');
          name.textContent = reviewName ? reviewName.textContent : '';
          copy.textContent = reviewCopy ? reviewCopy.textContent : '';
          if (stars){
            var score = Math.max(0, Math.min(5, Number(review.getAttribute('data-review-score')) || 0));
            stars.textContent = score + ' av 5';
            stars.setAttribute('aria-label', score + ' av 5 stjärnor');
          }
        }
      }
      filters.forEach(function(button){ button.addEventListener('click', function(){ showTheme(button); }); });
      if (filters[0]) showTheme(filters[0]);
    });

    root.querySelectorAll('[data-dj-review-carousel]').forEach(function(carousel){
      if (REDUCED) return;
      var track = carousel.querySelector('[data-dj-review-track]');
      var sequence = carousel.querySelector('[data-dj-review-sequence]');
      if (!track || !sequence) return;
      var setReviewSpeed = function(){
        var distance = sequence.getBoundingClientRect().width;
        if (distance > 0) track.style.setProperty('--dj-review-duration', Math.max(22, distance / 34) + 's');
      };
      setReviewSpeed();
      if ('ResizeObserver' in window){
        var reviewObserver = new ResizeObserver(setReviewSpeed);
        reviewObserver.observe(sequence);
      } else {
        window.addEventListener('resize', setReviewSpeed, { passive: true });
      }
    });

    var reveals = [].slice.call(root.querySelectorAll('[data-reveal], .dj-lst__item, .dj-lst__compare-wrap, .dj-lst__hero-img'));
    reveals.forEach(function(el, i){ el.style.transitionDelay = (Math.min(i % 4, 3) * 70) + 'ms'; });
    root.querySelectorAll('.dj-lst__compare tbody tr').forEach(function(tr, i){ tr.style.transitionDelay = (i * 45) + 'ms'; });

    var bar = root.querySelector('[data-dj-progress] span');
    var sticky = root.querySelector('[data-dj-sticky]');
    var observedChatHost = null;
    var observedChatShadow = null;
    var CHAT_BEHIND_STICKY_Z = '2147482000';

    function chatHost(){
      return document.querySelector('shopify-chat, inbox-online-store-chat');
    }
    function chatIsOpen(host){
      if (!host) return false;
      if (host.tagName === 'SHOPIFY-CHAT') return host.hasAttribute('open');
      return host.getAttribute('is-open') === 'true';
    }
    function hideStickyForChat(hide){
      if (!sticky) return;
      if (hide){
        if (sticky.getAttribute('data-dj-chat-hidden') !== 'true'){
          sticky.setAttribute('data-dj-chat-hidden', 'true');
          sticky.setAttribute('aria-hidden', 'true');
          sticky.setAttribute('inert', '');
          sticky.style.setProperty('visibility', 'hidden', 'important');
          sticky.style.setProperty('pointer-events', 'none', 'important');
        }
      } else if (sticky.getAttribute('data-dj-chat-hidden') === 'true'){
        sticky.removeAttribute('data-dj-chat-hidden');
        sticky.removeAttribute('aria-hidden');
        sticky.removeAttribute('inert');
        sticky.style.removeProperty('visibility');
        sticky.style.removeProperty('pointer-events');
      }
    }
    function clearOldChatLift(host){
      if (!host || host.getAttribute('data-dj-listicle-lift') !== 'true') return;
      host.style.removeProperty('transform');
      host.removeAttribute('data-dj-listicle-lift');
    }
    function setChatBehindSticky(host, cover){
      if (!host) return;
      var covered = host.getAttribute('data-dj-listicle-covered') === 'true';
      if (cover){
        if (!covered){
          host.setAttribute('data-dj-listicle-original-z', host.style.getPropertyValue('z-index') || '');
          host.setAttribute('data-dj-listicle-original-z-priority', host.style.getPropertyPriority('z-index') || '');
          host.setAttribute('data-dj-listicle-covered', 'true');
        }
        if (host.style.getPropertyValue('z-index') !== CHAT_BEHIND_STICKY_Z || host.style.getPropertyPriority('z-index') !== 'important'){
          host.style.setProperty('z-index', CHAT_BEHIND_STICKY_Z, 'important');
        }
        return;
      }
      if (!covered) return;
      var original = host.getAttribute('data-dj-listicle-original-z') || '';
      var priority = host.getAttribute('data-dj-listicle-original-z-priority') || '';
      if (original) host.style.setProperty('z-index', original, priority);
      else host.style.removeProperty('z-index');
      host.removeAttribute('data-dj-listicle-original-z');
      host.removeAttribute('data-dj-listicle-original-z-priority');
      host.removeAttribute('data-dj-listicle-covered');
    }
    function syncChatAndSticky(){
      if (!sticky) return;
      var host = chatHost();
      if (!host){
        hideStickyForChat(false);
        return;
      }
      clearOldChatLift(host);
      var mobileCover = window.matchMedia('(max-width: 749px)').matches;
      if (mobileCover && chatIsOpen(host)){
        setChatBehindSticky(host, false);
        hideStickyForChat(true);
        return;
      }
      hideStickyForChat(false);
      setChatBehindSticky(host, mobileCover && sticky.getAttribute('data-visible') === 'true');
    }
    function observeChat(){
      var host = chatHost();
      if (host && host !== observedChatHost){
        setChatBehindSticky(observedChatHost, false);
        observedChatHost = host;
        try {
          new MutationObserver(syncChatAndSticky).observe(host, {
            attributes: true,
            attributeFilter: ['style', 'is-open', 'open', 'view']
          });
        } catch (e) {}
      }
      if (host && host.shadowRoot && host.shadowRoot !== observedChatShadow){
        observedChatShadow = host.shadowRoot;
        try {
          new MutationObserver(syncChatAndSticky).observe(host.shadowRoot, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: ['class', 'style', 'part']
          });
        } catch (e) {}
      }
      syncChatAndSticky();
    }
    try {
      new MutationObserver(observeChat).observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-visible']
      });
    } catch (e) {}
    if (window.customElements && customElements.whenDefined){
      customElements.whenDefined('shopify-chat').then(observeChat).catch(function(){});
      customElements.whenDefined('inbox-online-store-chat').then(observeChat).catch(function(){});
    }
    window.addEventListener('load', observeChat);
    window.addEventListener('resize', syncChatAndSticky, { passive: true });
    observeChat();

    var offer = root.querySelector('.dj-lst__offer');
    var pct = sticky ? (parseInt(sticky.getAttribute('data-threshold') || '10', 10) / 100) : 0.1;
    var pulsed = false;


    root.querySelectorAll('[data-dj-scenario]').forEach(function(scenario){
      var range = scenario.querySelector('[data-dj-scenario-range]');
      var input = scenario.querySelector('[data-dj-scenario-input]');
      var rangeOut = scenario.querySelector('[data-dj-scenario-range-output]');
      var currentOut = scenario.querySelector('[data-dj-scenario-current]');
      var productOut = scenario.querySelector('[data-dj-scenario-product]');
      var differenceOut = scenario.querySelector('[data-dj-scenario-difference]');
      var paybackOut = scenario.querySelector('[data-dj-scenario-payback]');
      var currentBar = scenario.querySelector('[data-dj-scenario-current-bar]');
      var productBar = scenario.querySelector('[data-dj-scenario-product-bar]');
      var mode = scenario.getAttribute('data-mode') || 'cost';
      var productKr = (Number(scenario.getAttribute('data-product-cents')) || 0) / 100;
      var multiplier = Number(scenario.getAttribute('data-multiplier')) || 1;
      var unit = rangeOut ? (rangeOut.textContent || '').replace(/^\s*[\d.,]+\s*/, '') : '';
      var metric = new Intl.NumberFormat('sv-SE', { maximumFractionDigits: 1 });

      function animateMetric(el, to, suffix){
        if (!el) return;
        var from = Number(el.getAttribute('data-v')) || 0;
        el.setAttribute('data-v', String(to));
        var draw = function(value){ el.textContent = metric.format(value) + suffix; };
        if (REDUCED || typeof requestAnimationFrame !== 'function' || from === to){ draw(to); return; }
        var started = null;
        function frame(now){
          if (started === null) started = now;
          var progress = Math.min(1, (now - started) / 520);
          var eased = 1 - Math.pow(1 - progress, 3);
          draw(from + (to - from) * eased);
          if (progress < 1) requestAnimationFrame(frame); else draw(to);
        }
        requestAnimationFrame(frame);
      }

      function updateScenario(){
        var quantity = Math.max(0, Number(range && range.value) || 0);
        var perEvent = Math.max(0, Number(input && input.value) || 0);
        if (rangeOut) rangeOut.textContent = metric.format(quantity) + (unit ? ' ' + unit : '');
        if (range){
          var min = Number(range.min) || 0;
          var max = Number(range.max) || 1;
          var pctRange = Math.max(0, Math.min(100, (quantity - min) / Math.max(1, max - min) * 100));
          range.style.setProperty('--dj-range', pctRange + '%');
        }

        if (mode === 'time'){
          var weeklyMinutes = quantity * perEvent * multiplier;
          var annualHours = weeklyMinutes * 52 / 60;
          animateMetric(currentOut, weeklyMinutes, ' min');
          animateMetric(productOut, annualHours, ' tim');
          if (differenceOut) differenceOut.textContent = metric.format(annualHours) + ' timmar per år';
          var maxTime = Math.max(weeklyMinutes, annualHours, 1);
          if (currentBar) currentBar.style.width = (weeklyMinutes / maxTime * 100) + '%';
          if (productBar) productBar.style.width = (annualHours / maxTime * 100) + '%';
        } else {
          var currentKr = quantity * perEvent * multiplier;
          animateMetric(currentOut, currentKr, ' kr');
          animateMetric(productOut, productKr, ' kr');
          var difference = currentKr - productKr;
          if (differenceOut){
            differenceOut.textContent = perEvent <= 0 ? 'Ange din egen kostnad ovan' : metric.format(Math.abs(difference)) + ' kr';
            differenceOut.parentElement.setAttribute('data-state', difference >= 0 ? 'positive' : 'neutral');
          }
          if (paybackOut){
            if (perEvent > 0 && productKr > 0){
              var paybackUses = Math.max(1, Math.ceil(productKr / perEvent));
              paybackOut.textContent = 'Med ditt angivna pris motsvarar produktpriset cirka ' + metric.format(paybackUses) + ' tillfällen.';
            } else {
              paybackOut.textContent = 'Fyll i din egen kostnad för att se hur många tillfällen som motsvarar produktpriset.';
            }
          }
          var maxCost = Math.max(currentKr, productKr, 1);
          if (currentBar) currentBar.style.width = (currentKr / maxCost * 100) + '%';
          if (productBar) productBar.style.width = (productKr / maxCost * 100) + '%';
        }
      }

      if (range) range.addEventListener('input', updateScenario);
      if (input) input.addEventListener('input', updateScenario);
      updateScenario();
    });

    var calc = root.querySelector('[data-dj-calc]');
    var calcRan = false;
    var runCalc = function(){};

    if (calc){
      var num = function(a){ return Number(calc.getAttribute(a)) || 0; };
      var outOurs = calc.querySelector('[data-dj-ours]');
      var outRival = calc.querySelector('[data-dj-rival]');
      var outSave = calc.querySelector('[data-dj-save]');
      var fillOurs = calc.querySelector('[data-dj-fill-ours]');
      var fillRival = calc.querySelector('[data-dj-fill-rival]');
      var pills = [].slice.call(calc.querySelectorAll('[data-dj-years]'));

      runCalc = function(years){
        var ours = num('data-our-device') + num('data-our-yearly') * years;
        var rival = num('data-rival-device') + num('data-rival-monthly') * 12 * years;
        var max = Math.max(ours, rival) || 1;
        if (outOurs) countUp(outOurs, ours);
        if (outRival) countUp(outRival, rival);
        if (outSave) countUp(outSave, Math.max(0, rival - ours));
        if (fillOurs) fillOurs.style.width = (ours / max * 100) + '%';
        if (fillRival) fillRival.style.width = (rival / max * 100) + '%';
      };

      pills.forEach(function(p){
        p.addEventListener('click', function(){
          pills.forEach(function(o){ o.setAttribute('aria-pressed', 'false'); });
          p.setAttribute('aria-pressed', 'true');
          calcRan = true;
          runCalc(Number(p.getAttribute('data-dj-years')));
        });
      });

      var pre = calc.querySelector('[data-dj-years][aria-pressed="true"]');
      calc._years = pre ? Number(pre.getAttribute('data-dj-years')) : 3;
    }

    function tick(){
      var vh = window.innerHeight;
      var trigger = vh * 0.9;

      for (var i = reveals.length - 1; i >= 0; i--){
        var el = reveals[i];
        var r = el.getBoundingClientRect();
        if (r.top < trigger && r.bottom > 0){
          el.classList.add('is-in');
          reveals.splice(i, 1);
        }
      }

      if (calc && !calcRan){
        var cr = calc.getBoundingClientRect();
        if (cr.top < vh && cr.bottom > 0){ calcRan = true; runCalc(calc._years); }
      }

      var docH = document.documentElement.scrollHeight - vh;
      var y = window.scrollY || document.documentElement.scrollTop || 0;

      if (bar) bar.style.width = (Math.max(0, Math.min(1, docH > 0 ? y / docH : 0)) * 100) + '%';

      if (sticky){
        var passed = y > vh * 0.5 && (docH <= 0 || y > docH * pct);
        var atOffer = false;
        if (offer){
          var orr = offer.getBoundingClientRect();
          atOffer = orr.top < vh && orr.bottom > 0;
        }
        var show = passed && !atOffer;
        sticky.setAttribute('data-visible', show ? 'true' : 'false');
        syncChatAndSticky();
        if (show && !pulsed && !REDUCED){
          pulsed = true;
          sticky.classList.add('dj-lst__sticky--pulse');
          setTimeout(function(){ sticky.classList.remove('dj-lst__sticky--pulse'); }, 2600);
        }
      }
    }

    var last = 0;
    var queued = null;
    function onScroll(){
      var now = Date.now();
      if (now - last > 80){ last = now; tick(); return; }
      if (queued) return;
      queued = setTimeout(function(){ queued = null; last = Date.now(); tick(); }, 90);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });

    tick();
    setTimeout(tick, 250);
    setTimeout(tick, 900);
    setTimeout(function(){ if (calc && !calcRan){ calcRan = true; runCalc(calc._years); } }, 1600);
  }

  function boot(){
    document.querySelectorAll('[data-dj-listicle]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', boot);
})();
